export default "__VITE_ASSET__7NvEIH$x__"